import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CommonState, CustomerOfferAction, CustomerOfferSelector, FulfillmentStep, Offer } from "@obg/ngx.common";
import { ignoreNil } from "@obg/rxjs";
import { merge, Observable, Subscription } from "rxjs";
import { filter, switchMap, take, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-visitor-bonus-container",
	templateUrl: "./visitor-bonus.container.html",
	styleUrls: ["./visitor-bonus.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class VisitorBonusContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-visitor-bonus") hostClass = true;

	@Input() countryCode: string | undefined;
	@Output() bonusSelected = new EventEmitter<Offer | undefined>();

	offers$: Observable<Offer[] | undefined> | undefined;

	private data$$: Subscription | undefined;

	constructor(
		private store: Store<CommonState>,
		private customerOfferSelector: CustomerOfferSelector,
		private customerOfferAction: CustomerOfferAction
	) {}

	ngOnInit() {
		this.store.dispatch(this.customerOfferAction.getVisitorOffers());

		this.offers$ = this.store.pipe(
			select(this.customerOfferSelector.getVisitorOffers(FulfillmentStep.deposit)),
			ignoreNil(),
			take(1)
		);

		const noOffers$ = this.offers$.pipe(
			switchMap(() =>
				this.store.pipe(
					select(this.customerOfferSelector.hasVisitorOffers()),
					filter((hasOffers) => !hasOffers),
					tap(() => this.bonusSelected.emit())
				)
			)
		);

		const bonusFailed$ = this.store.pipe(
			select(this.customerOfferSelector.isFail()),
			filter((isFail) => isFail),
			tap(() => this.bonusSelected.emit())
		);

		this.data$$ = merge(noOffers$, bonusFailed$).subscribe();
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	onBonusSelected(offer: Offer | undefined) {
		this.bonusSelected.emit(offer);
	}
}
